



















import Vue from "vue";
import $store from "@/store/store";
import { Prop, Watch } from "vue-property-decorator";
import Component, { mixins } from "vue-class-component";

@Component({
  components: {},
})
export default class NumericPad extends Vue {
  public writeMe(event: string) {
    this.$emit("write", event);
  }
}
